import React, { useState, useEffect, useRef } from "react";

import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { Spinner, Alert, ButtonGroup } from "react-bootstrap";

import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { de } from "date-fns/locale/de";
registerLocale("de", de);

import CurrencyInput from "react-currency-input-field";
import postIcon from "./img/papierflieger.webp";
import { invisiblestring, statusfarben, statusfarbentext } from "./globalVariables";
import { evaluateRule, isValidDate } from "./pureFunctions";
import { useConfig } from "./ConfigContext";
import MySelect from "./MySelect";

import EditField from "./Settings/EditField";
import Spracheingabe from "./Spracheingabe";
import { formatText } from "./formatFunctions";
import SharepointExplorer from "./SharepointExplorer";

const maxTextarea = 2000;

export default function KachelForm({
   setShowAll,
   showAll,
   sendData,
   data,
   changeData,
   eskstatus,
   changeEskStatus,
   kachelData,
   createOOTask,
   estateId,
   loading,
   user,
   handleElementBlock,
   currentElement,
   blockedField,
   teamsChannelNotification,
   userlist,
   fieldconfiguration,
   editLayout,
   allKacheln,
   setAllKacheln,

   sharepointObject,
   loadSharepointData,
}) {
   const config = useConfig();
   const [allowCheck, setAllowCheck] = useState(false);
   const [inputkeys, setInputkeys] = useState();
   const [showPostIcon, setShowPostIcon] = useState(false);
   const [statusColor, setStatusColor] = useState("white");
   const [userNotizcheck, setUserNotizcheck] = useState(false);
   const [pmNotizcheck, setPMNotizcheck] = useState(false);
   const [dangerField, setDangerField] = useState("");
   const [currentField, setCurrentField] = useState("");
   const [prevField, setPrevField] = useState("");
   function changeAllowedCheck(name, isPublicData) {
      if (isPublicData) {
         if (
            (data[config.estate.verkaufsStatus] === config.select.statusVorlaufOnline ||
               data[config.estate.verkaufsStatus] === config.select.statusAktiv) &&
            data[name]
         ) {
            setDangerField(name);
         }
      }
   }

   useEffect(() => {
      console.log(user);

      /* Check, ob es eine Pflichtkachel ist, wenn ja, check, ob Pflichtfelder */
      console.log(kachelData);

      if (kachelData.pflichtKachel) {
         const newkachelkeys = kachelData.fields
            .flat()
            .filter((item) => !item.optional)
            .map((item) => ({
               name: item.name,
               filter: item.filter ? item.filter : false,
            }));
         if (newkachelkeys.length === 0) {
            setAllowCheck(true);
         }
         setInputkeys(newkachelkeys);
      } else {
         setAllowCheck(true);
      }
      return () => {
         setAllowCheck(false);
      };
   }, []);

   useEffect(() => {
      console.log("allowCheck: " + allowCheck);
   }, [allowCheck]);

   useEffect(() => {
      /* Kachelvalidierung */
      const kachelstatus =
         eskstatus["kachel_status_" + kachelData.kachelId] < 4 &&
         kachelData.pflichtEskalation &&
         new Date(eskstatus["kachel_eskalation_" + kachelData.kachelId]) < new Date()
            ? -1
            : eskstatus["kachel_status_" + kachelData.kachelId];

      setStatusColor(statusfarben[kachelstatus]);

      if (data && inputkeys && inputkeys.length && kachelData.pflichtKachel) {
         let newValidate = true;
         // console.log(inputkeys);

         for (const inputkey of inputkeys) {
            if (inputkey.filter) {
               if (evaluateRule(data, inputkey.filter, showAll)) {
                  if (
                     data[inputkey.name] === undefined ||
                     data[inputkey.name] === null ||
                     data[inputkey.name] === "0000-00-00"
                  ) {
                     newValidate = false;
                  } else if (data[inputkey.name].toString().length < 1) {
                     newValidate = false;
                  }
               }
            } else if (
               data[inputkey.name] === undefined ||
               data[inputkey.name] === null ||
               data[inputkey.name] === "0000-00-00"
            ) {
               newValidate = false;
            } else if (data[inputkey.name].toString().length < 1) {
               newValidate = false;
            }
            if (!newValidate) break;
         }
         setAllowCheck(newValidate);
      }
   }, [data, eskstatus, inputkeys]);

   function checkSingleClick(oneClickFinish, myData) {
      let result = false;
      if (oneClickFinish && oneClickFinish.length) {
         result = true;
         oneClickFinish.forEach((item) => {
            if (myData[item[0]] != item[1]) {
               result = false;
            }
         });
      }

      return result;
   }

   return (
      <Form autoComplete="off">
         {kachelData.fields.map((row, rowindex) => {
            return (
               <Row
                  key={"Kachelreihe_" + kachelData.kachelId + rowindex}
                  style={{
                     ...(editLayout
                        ? { borderRadius: "10px", border: "solid 1px #0002", margin: "5px 0", padding: "0" }
                        : {}),
                  }}
               >
                  {row.length === 0 && editLayout && (
                     <EditField
                        rowIndex={rowindex}
                        colIndex={"empty"}
                        data={kachelData}
                        allKacheln={allKacheln}
                        setAllKacheln={setAllKacheln}
                        fieldconfiguration={fieldconfiguration}
                     />
                  )}
                  {row.map((column, columnindex) => {
                     let showfield = false;
                     if (column.filter) {
                        showfield = evaluateRule(data, column.filter, showAll);
                     } else {
                        if (column.deprecated && !data[column.name]) {
                           showfield = false;
                        } else {
                           showfield = true;
                        }
                     }
                     if (showfield || editLayout) {
                        return (
                           <Col
                              className={column.name === prevField ? "field-success" : ""}
                              style={{
                                 // outline: "solid red 2px",

                                 ...(column.deprecated ? { filter: "brightness(0.8)", pointerEvents: "none" } : {}),
                                 ...(blockedField[column.name]
                                    ? {
                                         opacity: 0.8,
                                         borderRadius: "6px",
                                         boxShadow: "0 0 20px #999",
                                         pointerEvents: "none",
                                         position: "relative",
                                      }
                                    : { position: "relative" }),
                              }}
                              onFocus={(e) => {
                                 // console.log(e.target);
                                 // console.log(e);
                                 setCurrentField(column.name);
                                 changeAllowedCheck(column.name, column.onOffice);
                                 handleElementBlock(true, column.name, data[column.name]);
                              }}
                              onBlur={(e) => {
                                 /*   console.log(e.target);
                                 console.log(e.relatedTarget); */
                                 // console.log(e);

                                 console.log(e.relatedTarget ? "richtiger Blur" : "falscher Blur");
                                 setDangerField("");
                                 setPrevField(column.name);
                                 setCurrentField("");

                                 handleElementBlock(false, column.name, data[column.name]);
                              }}
                              md={12 / row.length}
                              key={"Kachelreihe_" + kachelData.kachelId + rowindex + "_" + columnindex}
                           >
                              {config.company === "bender" && column.onOffice && (
                                 <div
                                    title={
                                       "onOffice Feld: " +
                                       column.onOffice +
                                       " Label: " +
                                       fieldconfiguration?.[column.module ?? "estate"]?.[column.onOffice]?.label
                                    }
                                    style={{
                                       position: "absolute",
                                       // left: "5px",
                                       background: "#0001",
                                       width: "25px",
                                       height: "38px",
                                       borderRadius: 8,
                                       zIndex: 1,
                                    }}
                                 ></div>
                              )}
                              {editLayout && (
                                 <EditField
                                    rowIndex={rowindex}
                                    colIndex={columnindex}
                                    data={kachelData}
                                    allKacheln={allKacheln}
                                    setAllKacheln={setAllKacheln}
                                    fieldconfiguration={fieldconfiguration}
                                 />
                              )}
                              {blockedField[column.name] && (
                                 <div style={{ position: "absolute", right: 14, color: "#f0a", top: 4 }}>
                                    ... wird bearbeitet von {blockedField[column.name]?.user?.Name}
                                 </div>
                              )}
                              {column.type === "hline" && <hr />}
                              {column.type === "note" && (
                                 <div>
                                    <strong>{column.heading}</strong>
                                 </div>
                              )}
                              {column.type === "teamsbutton" && (
                                 <div className="mb-2 w-50">
                                    {showPostIcon && (
                                       <div className="post-image">
                                          <img src={postIcon} alt="" />
                                       </div>
                                    )}
                                    <Button
                                       disabled={loading === "loading"}
                                       variant="dark"
                                       className="px-5 p-2 w-100 teams-button"
                                       style={column.style ? column.style : { backgroundColor: "#3D2F81" }}
                                       onClick={() => {
                                          setShowPostIcon(true);
                                          teamsChannelNotification(column);

                                          setTimeout(() => {
                                             setShowPostIcon(false);
                                          }, 1900);
                                       }}
                                    >
                                       {column.buttonName ? column.buttonName : "Teams benachrichten"}
                                    </Button>
                                 </div>
                              )}
                              {column.type === "ooAufgabe" && (
                                 <div className="mb-2">
                                    {showPostIcon && (
                                       <div className="post-image">
                                          <img src={postIcon} alt="" />
                                       </div>
                                    )}
                                    <Button
                                       disabled={loading === "loading"}
                                       variant="secondary"
                                       className="px-5 p-2"
                                       onClick={() => {
                                          setShowPostIcon(true);
                                          createOOTask(column.tasktype);
                                          setTimeout(() => {
                                             setShowPostIcon(false);
                                          }, 1900);
                                       }}
                                    >
                                       oO Aufgabe erstellen
                                    </Button>
                                 </div>
                              )}

                              {column.type === "empty" && <Form.Group className="mb-2 mt-2" as={Col}></Form.Group>}
                              {column.type === "textarea" && (
                                 <>
                                    {/* <Spracheingabe ></Spracheingabe> */}
                                    <Form.Group
                                       className="mb-2 mt-2"
                                       as={Col}
                                       key={"S_" + rowindex + "_" + columnindex}
                                       title={column.title ? column.title : ""}
                                    >
                                       <Form.Label>
                                          {column.heading}
                                          {column.title ? "*" : ""}
                                       </Form.Label>
                                       {dangerField === column.name && (
                                          <div
                                             style={{
                                                backgroundColor: "#e00",
                                                color: "#fff",
                                                padding: "4px 10px",
                                                marginBottom: "10px",
                                             }}
                                          >
                                             Achtung! Diese Daten sind veröffentlicht! Sind Änderungen mit Grafik usw.
                                             abgesprochen?
                                          </div>
                                       )}
                                       {column.richText && data[column.name] && (
                                          <div
                                             style={{
                                                fieldSizing: "content",
                                                padding: "10px",
                                                whiteSpace: "pre-line",
                                                background: "#efefef",
                                                borderRadius: 10,
                                             }}
                                          >
                                             {formatText(data[column.name])}
                                          </div>
                                       )}
                                       <InputGroup className="mb-2 mt-2">
                                          <Form.Control
                                             className={column.optional ? "" : data[column.name] ? "" : "empty-field"}
                                             as="textarea"
                                             placeholder=""
                                             disabled={column.readOnly}
                                             maxLength={column.maxLength ? column.maxLength : undefined}
                                             onChange={(e) => {
                                                changeData(e.target.name, e.target.value, "single");
                                             }}
                                             name={column.name}
                                             value={data[column.name]}
                                             style={{ minHeight: "115px", fieldSizing: "content" }}
                                          />
                                          <Button
                                             variant={data[column.name] ? "outline-light" : "dark"}
                                             id="button-addon2"
                                             disabled={column.readOnly}
                                             onClick={(e) =>
                                                changeData(
                                                   column.name,
                                                   true ? invisiblestring : data[column.name],
                                                   "single",
                                                )
                                             }
                                          ></Button>
                                       </InputGroup>
                                       {/* )} */}
                                       {column.maxLength && (
                                          <Form.Text muted>
                                             <span
                                                style={
                                                   data[column.name].length ===
                                                   (column.maxLength ? column.maxLength : maxTextarea)
                                                      ? { backgroundColor: "#b60", color: "#fff", padding: "4px 10px" }
                                                      : null
                                                }
                                             >
                                                {data[column.name] ? data[column.name].length : 0}/
                                                {column.maxLength ? column.maxLength : maxTextarea}
                                             </span>
                                          </Form.Text>
                                       )}
                                    </Form.Group>
                                 </>
                              )}
                              {column.type === "select" && (
                                 <MySelect
                                    basicdata={data}
                                    data={column}
                                    multiselect={column.multi}
                                    changeData={changeData}
                                    value={data[column.name] ? data[column.name] : ""}
                                 />
                              )}
                              {column.type === "boolean" && (
                                 <Form.Group
                                    as={Col}
                                    controlId={"id_" + column.name}
                                    className="mb-2 mt-2"
                                    title={column.title ? column.title : ""}
                                 >
                                    <Form.Label>
                                       {column.heading}
                                       {column.title ? "*" : ""}
                                    </Form.Label>

                                    <Form.Select
                                       disabled={column.readOnly}
                                       className={column.optional ? "" : data[column.name] ? "" : "empty-field"}
                                       name={column.name}
                                       onChange={(e) => {
                                          console.log(e);
                                          changeData(e.target.name, e.target.value, "single");
                                       }}
                                       value={data[column.name] ?? "0"}
                                    >
                                       <option value="0">Nein</option>
                                       <option value="1">Ja</option>
                                    </Form.Select>
                                 </Form.Group>
                              )}

                              {column.type === "singleselect" && (
                                 <MySelect
                                    basicdata={data}
                                    fieldconfiguration={
                                       fieldconfiguration &&
                                       fieldconfiguration[column.module] &&
                                       fieldconfiguration[column.module][column.onOffice]
                                    }
                                    isPublished={dangerField === column.name}
                                    multiselect={false}
                                    data={column}
                                    changeData={changeData}
                                    value={data[column.name] ? data[column.name] : ""}
                                    onOffice={true}
                                 />
                              )}
                              {column.type === "multiselect" && (
                                 <MySelect
                                    basicdata={data}
                                    fieldconfiguration={
                                       fieldconfiguration && fieldconfiguration[column.module][column.onOffice]
                                    }
                                    isPublished={dangerField === column.name}
                                    multiselect={true}
                                    data={column}
                                    changeData={changeData}
                                    value={data[column.name] ? data[column.name] : ""}
                                    onOffice={true}
                                 />
                              )}
                              {column.type === "userName" && (
                                 <Form.Group
                                    as={Col}
                                    controlId={"id_" + column.name}
                                    className="mb-2 mt-2"
                                    title={column.title ? column.title : ""}
                                 >
                                    <Form.Label>
                                       {column.heading}
                                       {column.title ? "*" : ""}
                                    </Form.Label>

                                    <Form.Select
                                       className={column.optional ? "" : data[column.name] ? "" : "empty-field"}
                                       name={column.name}
                                       onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                                       value={data[column.name] ? data[column.name] : ""}
                                    >
                                       <option value=""></option>
                                       <option value={user.Name}>
                                          {user.Vorname ? `${user.Vorname} ${user.Nachname}` : user.Name}
                                       </option>
                                       {userlist &&
                                          userlist.map((user, index) => (
                                             <option key={"selectuser_" + user.Name + column.name} value={user.Name}>
                                                {user.Nachname + " " + user.Vorname}
                                             </option>
                                          ))}
                                    </Form.Select>
                                 </Form.Group>
                              )}
                              {column.type === "currentUser" && (
                                 <Form.Group
                                    as={Col}
                                    controlId={"id_" + column.name}
                                    className="mb-2 mt-2"
                                    title={column.title ? column.title : ""}
                                 >
                                    <Form.Label>
                                       {column.heading}
                                       {column.title ? "*" : ""}
                                    </Form.Label>

                                    <Form.Select
                                       className={column.optional ? "" : data[column.name] ? "" : "empty-field"}
                                       name={column.name}
                                       onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                                       value={data[column.name] ? data[column.name] : ""}
                                    >
                                       <option value=""></option>
                                       <option value={user.Name}>
                                          {user.Vorname} {user.Nachname}
                                       </option>
                                       {userlist &&
                                          userlist.map((user, index) => (
                                             <option
                                                disabled
                                                style={{ opacity: 0.3 }}
                                                key={"selectuser_" + user.Name + column.name}
                                                value={user.Name}
                                             >
                                                {user.Nachname + " " + user.Vorname}
                                             </option>
                                          ))}
                                    </Form.Select>
                                 </Form.Group>
                              )}
                              {column.type === "user" && (
                                 <Form.Group
                                    as={Col}
                                    controlId={"id_" + column.name}
                                    className="mb-2 mt-2"
                                    title={column.title ? column.title : ""}
                                 >
                                    <Form.Label>
                                       {column.heading}
                                       {column.title ? "*" : ""}
                                    </Form.Label>

                                    <Form.Select
                                       className={column.optional ? "" : data[column.name] ? "" : "empty-field"}
                                       name={column.name}
                                       onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                                       value={data[column.name] ? data[column.name] : ""}
                                    >
                                       <option value=""></option>
                                       <option value={user.id}>
                                          {user.Vorname} {user.Nachname}
                                       </option>
                                       {userlist &&
                                          userlist.map((user, index) => {
                                             // console.log(user);
                                             return (
                                                <option key={"selectuser_" + user.Name + column.name} value={user.id}>
                                                   {user.Nachname + " " + user.Vorname}
                                                </option>
                                             );
                                          })}
                                    </Form.Select>
                                 </Form.Group>
                              )}
                              {column.type === "readOnly_user" && (
                                 <Form.Group
                                    as={Col}
                                    controlId={"id_" + column.name}
                                    className="mb-2 mt-2"
                                    title={column.title ? column.title : ""}
                                 >
                                    <Form.Label>
                                       {column.heading}
                                       {column.title ? "*" : ""}
                                    </Form.Label>
                                    <Form.Control
                                       className={column.optional ? "" : data[column.name] ? "" : "empty-field"}
                                       disabled={true}
                                       onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                                       name={column.name}
                                       value={user.Name}
                                    />
                                 </Form.Group>
                              )}

                              {(column.type === "text" || column.type === "varchar") && (
                                 <Form.Group
                                    as={Col}
                                    controlId={"id_" + column.name}
                                    className="mb-2 mt-2"
                                    title={column.title ? column.title : ""}
                                 >
                                    <Form.Label>
                                       {column.heading}
                                       {column.title ? "*" : ""}
                                    </Form.Label>
                                    {dangerField === column.name && (
                                       <div
                                          style={{
                                             backgroundColor: "#e00",
                                             color: "#fff",
                                             padding: "4px 10px",
                                             marginBottom: "10px",
                                          }}
                                       >
                                          Achtung! Diese Daten sind veröffentlicht! Sind Änderungen mit Grafik usw.
                                          abgesprochen?
                                       </div>
                                    )}

                                    <InputGroup>
                                       <Form.Control
                                          /* onBlur={() => setDangerField("")}
                                          onFocus={(e) => changeAllowedCheck(e, column.onOffice)} */
                                          className={column.optional ? "" : data[column.name] ? "" : "empty-field"}
                                          autoComplete={column.autoComplete ? "" : "off"}
                                          disabled={column.readOnly}
                                          maxLength={column.maxLength ? column.maxLength : undefined}
                                          onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                                          name={column.name}
                                          value={data[column.name]}
                                       />
                                       {!column.readOnly && (
                                          <Button
                                             variant={data[column.name] ? "outline-light" : "dark"}
                                             id="button-addon2"
                                             onClick={(e) =>
                                                changeData(
                                                   column.name,
                                                   true ? invisiblestring : data[column.name],
                                                   "single",
                                                )
                                             }
                                          ></Button>
                                       )}
                                    </InputGroup>
                                    {column.maxLength && (
                                       <Form.Text muted>
                                          <span
                                             style={{
                                                marginLeft: "10px",
                                                ...(data[column.name] && data[column.name].length === column.maxLength
                                                   ? { color: "#d00", fontWeight: 700 }
                                                   : {}),
                                             }}
                                          >
                                             {data[column.name] ? data[column.name].length : 0}
                                          </span>
                                          /{column.maxLength}
                                       </Form.Text>
                                    )}
                                 </Form.Group>
                              )}
                              {column.type === "file" && (
                                 <Form.Group
                                    as={Col}
                                    controlId={"id_" + column.name}
                                    className="mb-2 mt-2"
                                    title={column.title ? column.title : ""}
                                 >
                                    <Form.Label>
                                       {column.heading}
                                       {column.title ? "*" : ""}
                                    </Form.Label>

                                    <div className="flex-row">
                                       <ButtonGroup className="w-100">
                                          <SharepointExplorer
                                             buttonClassName={
                                                column.optional ? "" : data[column.name] ? "" : "empty-field"
                                             }
                                             sharepointObject={sharepointObject}
                                             loadSharepointData={loadSharepointData}
                                             selectedFiles={[data[column.name]]}
                                             label={data[column.name] ? "bearbeiten" : " + Neue Datei"}
                                             hideOnSelect={true}
                                             handleFileSelect={(item) => {
                                                console.log(item);
                                                console.log(sharepointObject?.[item]);

                                                changeData(column.name, item, "single");
                                             }}
                                          />
                                          {data[column.name] && (
                                             <>
                                                <a
                                                   className="btn btn-outline-dark w-100 "
                                                   rel="noopener noreferrer"
                                                   target="_blank"
                                                   href={sharepointObject?.[data?.[column.name]]?.webUrl}
                                                >
                                                   {sharepointObject?.[data?.[column.name]]?.name} ↗
                                                </a>
                                                <Button
                                                   variant="dark"
                                                   onClick={() => {
                                                      changeData(column.name, "", "single");
                                                   }}
                                                >
                                                   x
                                                </Button>
                                             </>
                                          )}
                                       </ButtonGroup>{" "}
                                    </div>
                                 </Form.Group>
                              )}
                              {(column.type === "number" || column.type === "float" || column.type === "integer") && (
                                 <Form.Group
                                    as={Col}
                                    controlId={"id_" + column.name}
                                    className="mb-2 mt-2"
                                    title={column.title ? column.title : ""}
                                 >
                                    <Form.Label>
                                       {column.heading}
                                       {column.title ? "*" : ""}
                                    </Form.Label>
                                    {dangerField === column.name && (
                                       <div
                                          style={{
                                             backgroundColor: "#e00",
                                             color: "#fff",
                                             padding: "4px 10px",
                                             marginBottom: "10px",
                                          }}
                                       >
                                          Achtung! Diese Daten sind veröffentlicht! Sind Änderungen mit Grafik usw.
                                          abgesprochen?
                                       </div>
                                    )}
                                    <Form.Control
                                       /* onBlur={() => setDangerField("")}
                                       onFocus={(e) => changeAllowedCheck(e, column.onOffice)} */
                                       className={column.optional ? "" : data[column.name] ? "" : "empty-field"}
                                       type="number"
                                       step={column.type === "integer" ? 1 : column.step ? column.step : 0.01}
                                       onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                                       name={column.name}
                                       value={data[column.name]}
                                    />
                                 </Form.Group>
                              )}
                              {column.type === "currency" && (
                                 <Form.Group
                                    as={Col}
                                    controlId={"id_" + column.name}
                                    className="mb-2 mt-2"
                                    title={column.title ? column.title : ""}
                                 >
                                    <Form.Label>
                                       {column.heading}
                                       {column.title ? "*" : ""}
                                    </Form.Label>

                                    <CurrencyInput
                                       className={
                                          column.optional
                                             ? "currency-input"
                                             : data[column.name]
                                               ? "currency-input"
                                               : "currency-input empty-field"
                                       }
                                       // id={column.name}
                                       name={column.name}
                                       placeholder="---"
                                       allowNegativeValue={false}
                                       decimalsLimit={2}
                                       suffix="€"
                                       decimalSeparator=","
                                       groupSeparator="."
                                       value={data[column.name]}
                                       onValueChange={(value, name, values) => changeData(name, value, "currency")}
                                    />
                                 </Form.Group>
                              )}
                              {column.type === "formatNumber" && (
                                 <Form.Group
                                    as={Col}
                                    controlId={"id_" + column.name}
                                    className="mb-2 mt-2"
                                    title={column.title ? column.title : ""}
                                 >
                                    <Form.Label>
                                       {column.heading}
                                       {column.title ? "*" : ""}
                                    </Form.Label>

                                    <CurrencyInput
                                       className={
                                          column.optional
                                             ? "currency-input"
                                             : data[column.name]
                                               ? "currency-input"
                                               : "currency-input empty-field"
                                       }
                                       // id={column.name}
                                       name={column.name}
                                       placeholder="---"
                                       allowNegativeValue={true}
                                       decimalsLimit={2}
                                       suffix=""
                                       decimalSeparator=","
                                       groupSeparator="."
                                       value={data[column.name]}
                                       onValueChange={(value, name, values) => changeData(name, value, "currency")}
                                    />
                                 </Form.Group>
                              )}
                              {column.type === "phonenumber" && (
                                 <Form.Group
                                    as={Col}
                                    controlId={"id_" + column.name}
                                    className="mb-2 mt-2"
                                    title={column.title ? column.title : ""}
                                 >
                                    <Form.Label>
                                       {column.heading}
                                       {column.title ? "*" : ""}
                                    </Form.Label>
                                    <Form.Control
                                       className={column.optional ? "" : data[column.name] ? "" : "empty-field"}
                                       type="tel"
                                       onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                                       name={column.name}
                                       value={data[column.name]}
                                    />
                                 </Form.Group>
                              )}
                              {column.type === "eskalation" && (
                                 <Form.Group
                                    as={Col}
                                    controlId={"id_" + column.name}
                                    className="mb-2 mt-2"
                                    title={column.title ? column.title : ""}
                                 >
                                    <Form.Label>
                                       {column.heading}
                                       {column.title ? "*" : ""}
                                    </Form.Label>

                                    <DatePicker
                                       isClearable
                                       disabled={column.readOnly}
                                       selected={isValidDate(data[column.name]) && new Date(data[column.name])}
                                       onChange={(value) => {
                                          changeEskStatus(
                                             kachelData.kachelId,
                                             "eskdatum",
                                             value,
                                             kachelData.pmFreigabe,
                                             kachelData.adminFreigabe,
                                          );
                                       }}
                                       value={eskstatus["globalAdmin_" + kachelData.kachelId]}
                                       className={
                                          column.optional
                                             ? "bootstrap-datepicker"
                                             : data[column.name]
                                               ? "bootstrap-datepicker"
                                               : "bootstrap-datepicker empty-field"
                                       }
                                       calendarClassName="custom-date-calendar"
                                       dateFormat="dd.MM.yyyy"
                                       // popperPlacement="bottom"
                                       locale="de"
                                    />
                                 </Form.Group>
                              )}
                              {(column.type === "datetime" || column.type === "date") && (
                                 <div className="col" style={{ position: "relative" }}>
                                    <Form.Group
                                       as={Col}
                                       controlId={"id_" + column.name}
                                       className="mb-2 mt-2"
                                       title={column.title ? column.title : ""}
                                    >
                                       <Form.Label>
                                          {column.heading}
                                          {column.title ? "*" : ""}
                                       </Form.Label>

                                       <DatePicker
                                          isClearable={!column.readOnly}
                                          disabled={column.readOnly}
                                          selected={isValidDate(data[column.name]) ? new Date(data[column.name]) : null}
                                          showTimeSelect={column.type === "datetime"}
                                          timeIntervals={5}
                                          // maxDate={new Date()}
                                          minDate={column.minDate ? new Date() : undefined}
                                          onChange={(value) => changeData(column.name, value, "single")}
                                          className={
                                             "bootstrap-datepicker " +
                                             (column.optional ||
                                             (data[column.name] && data[column.name] !== "0000-00-00")
                                                ? ""
                                                : " empty-field") +
                                             (column.readOnly ? " disabled" : "")
                                          }
                                          calendarClassName="custom-date-calendar"
                                          timeFormat="HH:mm"
                                          dateFormat={column.type === "datetime" ? "dd.MM.yyyy, HH:mm" : "dd.MM.yyyy"}
                                          // popperPlacement="bottom"
                                          locale="de"
                                       />
                                    </Form.Group>
                                    <button
                                       disabled={column.readOnly}
                                       title="heute und jetzt als Datum einstellen"
                                       className="now-button "
                                       onClick={(e) => {
                                          e.preventDefault();
                                          changeData(column.name, new Date(), "single");
                                       }}
                                    >
                                       {"˅"}
                                    </button>{" "}
                                 </div>
                              )}

                              {column.type === "link" && (
                                 <div className="mb-4">
                                    <a
                                       target="_blank"
                                       style={{ fontWeight: 700, fontSize: "larger" }}
                                       href={data[column.name]}
                                    >
                                       {column.heading}
                                    </a>
                                 </div>
                              )}
                              {column.deprecated && (
                                 <div
                                    style={{
                                       position: "absolute",
                                       top: 0,
                                       margin: 16,
                                       background: "#0000",
                                       padding: "2px 10px",
                                       right: 0,
                                    }}
                                 >
                                    (veraltet)
                                 </div>
                              )}
                           </Col>
                        );
                     }
                  })}
               </Row>
            );
         })}

         {allowCheck && !kachelData.oneClickFinish && (
            <>
               <div className="kachel-abschluss">
                  {!userNotizcheck && !eskstatus["kachelabschluss_von_" + kachelData.kachelId] && (
                     <Alert className="m-3 mx-0" variant="danger">
                        <label className="checkbox-container">
                           <input
                              className="me-1"
                              id={"usernotizcheck_" + kachelData.kachelId}
                              type="checkbox"
                              onChange={(e) => setUserNotizcheck(e.target.checked)}
                           />
                           Alle eventuellen Hinweise (Notar, Exposé etc.) eingetragen?
                        </label>
                     </Alert>
                  )}
                  <Row>
                     <Form.Group
                        className="mb-3 "
                        as={Col}
                        key={"kachelabschluss_von_"}
                        title="Ein Benutzer kann in einer Pflichtkachel nur gesetzt werden, wenn alle Pflichtfelder ausgefüllt, und der Hinweischeck abgehakt wurde."
                     >
                        <Form.Label>
                           {kachelData.pmFreigabe
                              ? "Bereich vorläufig vollständig abgeschlossen von ... (Projektmanagerfreigabe folgt)*"
                              : "Bereich endgültig vollständig abgeschlossen von ...*"}
                        </Form.Label>
                        <Form.Select
                           name={"kachelabschluss_von_" + kachelData.kachelId}
                           disabled={
                              (!allowCheck || !userNotizcheck) &&
                              !eskstatus["kachelabschluss_von_" + kachelData.kachelId]
                           }
                           className={eskstatus["kachelabschluss_von_" + kachelData.kachelId] ? "" : "empty-field"}
                           onChange={(e) => {
                              changeEskStatus(
                                 kachelData.kachelId,
                                 "normalname",
                                 e.target.value,
                                 kachelData.pmFreigabe,
                                 kachelData.adminFreigabe,
                              );
                           }}
                           value={
                              eskstatus["kachelabschluss_von_" + kachelData.kachelId]
                                 ? eskstatus["kachelabschluss_von_" + kachelData.kachelId]
                                 : ""
                           }
                        >
                           <option value=""></option>
                           <option value={user.Name}>
                              {user.Vorname ?? user.Name} {user.Nachname}
                           </option>
                           {userlist &&
                              userlist.map((user, index) => (
                                 <option key={"select_" + user + index} value={user.Name}>
                                    {user.Nachname + " " + user.Vorname}
                                 </option>
                              ))}
                        </Form.Select>
                     </Form.Group>
                  </Row>
                  {kachelData.pmFreigabe &&
                     !pmNotizcheck &&
                     !eskstatus["kachelabschluss_admin_von_" + kachelData.kachelId] && (
                        <Alert className="m-3 mx-0" variant="danger">
                           <label className="checkbox-container">
                              <input
                                 className="me-1"
                                 id={"pmnotizcheck_" + kachelData.kachelId}
                                 type="checkbox"
                                 onChange={(e) => {
                                    setPMNotizcheck(e.target.checked);
                                 }}
                              />
                              Alle eventuellen Hinweise (Notar, Exposé etc.) eingetragen?
                           </label>
                        </Alert>
                     )}
                  {
                     /* user.pm &&  */ kachelData.pmFreigabe && (
                        <Row>
                           <Form.Group className="mb-2 mt-2" as={Col} key={"kachelabschluss_von_admin"}>
                              <Form.Label>
                                 Bereich endgültig vollständig abgeschlossen von Projektmanager...{" "}
                                 {kachelData.adminFreigabe && <span>(Adminfreigabe folgt)</span>}
                              </Form.Label>
                              <Form.Select
                                 disabled={
                                    (!allowCheck || !pmNotizcheck) &&
                                    !eskstatus["kachelabschluss_admin_von_" + kachelData.kachelId]
                                 }
                                 className={
                                    eskstatus["kachelabschluss_admin_von_" + kachelData.kachelId] ? "" : "empty-field"
                                 }
                                 name={"kachelabschluss_admin_von_" + kachelData.kachelId}
                                 onChange={(e) => {
                                    changeEskStatus(
                                       kachelData.kachelId,
                                       "pmname",
                                       e.target.value,
                                       kachelData.pmFreigabe,
                                       kachelData.adminFreigabe,
                                    );
                                 }}
                                 value={eskstatus["kachelabschluss_admin_von_" + kachelData.kachelId]}
                              >
                                 <option value=""></option>
                                 <option value={user.Name}>
                                    {user.Vorname ?? user.Name} {user.Nachname}
                                 </option>
                                 {userlist &&
                                    userlist.map((user, index) => (
                                       <option key={"select_" + user + index} value={user.Name}>
                                          {user.Nachname + " " + user.Vorname}
                                       </option>
                                    ))}
                              </Form.Select>
                           </Form.Group>
                        </Row>
                     )
                  }
                  {["globaladmin", "admin"].includes(user.role) && kachelData.adminFreigabe && (
                     <Row>
                        <Form.Group className="mb-2 mt-2" as={Col} key={"globalAdmin"}>
                           <Form.Label>Adminfreigabe von ...</Form.Label>
                           <Form.Select
                              className={eskstatus["globalAdmin_" + kachelData.kachelId] ? "" : "empty-field"}
                              name={"globalAdmin_" + kachelData.kachelId}
                              onChange={(e) => {
                                 changeEskStatus(
                                    kachelData.kachelId,
                                    "adminname",
                                    e.target.value,
                                    kachelData.pmFreigabe,
                                    kachelData.adminFreigabe,
                                 );
                              }}
                              value={eskstatus["globalAdmin_" + kachelData.kachelId]}
                           >
                              <option value=""></option>
                              <option value={user.Name}>
                                 {user.Vorname} {user.Nachname}
                              </option>
                              {userlist &&
                                 userlist.map((user, index) => (
                                    <option key={"select_" + user + index} value={user.Name}>
                                       {user.Nachname + " " + user.Vorname}
                                    </option>
                                 ))}
                           </Form.Select>
                        </Form.Group>
                     </Row>
                  )}
               </div>
            </>
         )}
         {!editLayout && (
            <div className="d-flex justify-content-end mt-2">
               {loading === "loading" ? (
                  <Button variant="primary" disabled>
                     <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                  </Button>
               ) : (
                  <>
                     {checkSingleClick(kachelData.oneClickFinish, data) ? (
                        <Button
                           variant="primary"
                           className={"ms-2 pe-4 ps-4 abschluss-button"}
                           onClick={() => {
                              let newEskData = structuredClone(eskstatus);
                              newEskData["kachel_status_" + kachelData.kachelId] = 4;
                              newEskData["kachelabschluss_von_" + kachelData.kachelId] = user.Name;

                              sendData({ currentkachelid: kachelData.kachelId, postEskData: newEskData });
                           }}
                        >
                           Als {user.Name} Abschließen
                        </Button>
                     ) : (
                        <>
                           <Button
                              variant="primary"
                              className={
                                 "ms-2 pe-4 ps-4" +
                                 (eskstatus["kachel_status_" + kachelData.kachelId] === 4 ? " abschluss-button" : "")
                              }
                              onClick={() => sendData({ currentkachelid: kachelData.kachelId })}
                           >
                              {eskstatus["kachel_status_" + kachelData.kachelId] === 4 ? "Abschließen" : "Speichern"}
                           </Button>
                           <Button
                              variant="primary"
                              className={
                                 "ms-2 pe-4 ps-4" +
                                 (eskstatus["kachel_status_" + kachelData.kachelId] === 4 ? " abschluss-button" : "")
                              }
                              onClick={async () => {
                                 await sendData({ currentkachelid: kachelData.kachelId, closeKachel: true });
                              }}
                           >
                              {eskstatus["kachel_status_" + kachelData.kachelId] === 4
                                 ? "Abschließen und Schliessen"
                                 : "Speichern und Schliessen"}
                           </Button>
                        </>
                     )}
                  </>
               )}
            </div>
         )}
      </Form>
   );
}
